import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAsync } from "../lib/useAsync";
import { flag } from "../lib/flag";
import type { WorldElection } from "@shared/types";
import { useI18n } from "../i18n";

const OFFICE: Record<string, string> = { president: "PRES", congress: "CONG" };

// Live results ticker across the top — scrolls slowly, pauses on hover. Fed by
// the cross-country world feed; live races first, then upcoming.
export function Ticker() {
  const { t, locale } = useI18n();
  const nav = useNavigate();
  const { data } = useAsync(() => api.world(), []);
  const items = (data ?? [])
    .filter((e) => e.phase !== "done")
    .slice(0, 20);

  if (items.length === 0) return null;

  // Duplicate the list so the -50% keyframe loops seamlessly.
  const loop = [...items, ...items];
  return (
    <div className="ticker">
      <span className="label">{t("phase.live")}</span>
      <div className="track">
        {loop.map((e, i) => (
          <button key={i} type="button" className="it" onClick={() => nav(`/c/${e.countryId}/e/${e.id}`)}>
            {flag(e.countryCode)} <b>{e.countryName}</b> {OFFICE[e.type]} {tail(e, t, locale)}
          </button>
        ))}
      </div>
    </div>
  );
}

function tail(e: WorldElection, t: ReturnType<typeof useI18n>["t"], locale: string): string {
  const d = (iso: string) => new Date(iso).toLocaleDateString(locale);
  if (e.phase === "live") return `· ${t("ticker.liveCloses", { date: d(e.votesEndAt) })}`;
  return `· ${t("ticker.opens", { date: d(e.votesStartAt) })}`;
}
